<template>
  <div class="header-main">
    <!-- <div class="header-warp w1200">
      <img :src="logo" alt="" />
      <span>{{title}}</span>
    </div> -->
    <div class="user-main" v-if="isLogin">

      <ul class="user-info w1200" >
        <div class="left">
          <div>
            <router-link :to="{name:'Index'}"><img src="static/images/new_logo01.png" alt="" /></router-link>
          </div>

          <!-- <div class="index-tab"> <router-link :to="{name:'Index'}">首页</router-link></div> -->
        </div>
        <!-- <div class="left">会员中心</div> -->
        <div class="right"><span>用户：{{this.user}}</span><span>|</span><span class="out-login" @click="outLogin()">退出</span></div>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderNav',
  data () {
    return {
      logo: JSON.parse(localStorage.getItem('assoInfo')) ? JSON.parse(localStorage.getItem('assoInfo')).logo : 'static/images/logo.png',
      title: JSON.parse(localStorage.getItem('assoInfo')) ? JSON.parse(localStorage.getItem('assoInfo')).name : '世界跆拳道联盟',
      user: JSON.parse(localStorage.getItem('assoUserInfo')).memberName
    }
  },
  props: {
    current: {
      type: Number,
      default: 1
    },
    titleMsg: {
      type: String,
      default: '世界跆拳道联盟',
      isLogin: false
    }
  },
  methods: {
    outLogin () {
      localStorage.removeItem('assoUserInfo')
      this.$router.push({
        name: 'Index'
      })
    }
  },
  mounted () {

  },
  created () {
    document.title = this.titleMsg
    if (JSON.parse(localStorage.getItem('assoUserInfo')) && JSON.parse(localStorage.getItem('assoUserInfo')) !== {}) {
      this.isLogin = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .header-main{
    width: 100%;
    background-color: #fff;
  }
  .header-warp{
    padding: 20px 0px;
    overflow: hidden;
  }
  .header-warp img{
    width: 88px;
    height: 88px;
    float: left;
    overflow: hidden;
    border-radius: 50%;
  }
  .header-warp span{
    font-size: 48px;
    color: #fff;
    margin-left: 30px;
    float: left;
    margin-top: 10px;
  }
  .user-main{
    width: 100%;
    /* background: #cc0000; */
  }
  .user-info{
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0px;
    box-sizing: border-box;
    color:#000;
  }
  .left{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .index-tab{
    color:#000;
    width:134px;
    text-align: center;
  }
  .index-tab a{
    color: #000;
    font-size: 18px;

  }
  .right span{
    padding: 0px 10px;
  }
  .out-login{
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/UserCenter/UserHeaderNav.vue